export default __webpack_public_path__ + "static/media/balance-sheet-and-capital-structure-1.298359c9.png";